// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableSimple":"_29zmgu","heading":"_2p_d5-","table":"_2smbxw","tr":"Dqf3NR","td":"_3uJ9C5","th":"_1Vozte","thead":"eOiDbu"};